<header class="mst-header" role="banner">
    <div class="mst-header__container">
        <!-- Mobile: hamburger / back buttons -->
        @if (headerConfig().mode === 'hamburger') {
            <button
                class="mst-header__mobileMenu stack row xCenter yCenter hide-l w18 h18 mrAuto fit"
                type="button"
                aria-label="Apri menu di navigazione"
                [attr.aria-expanded]="sideMenuIsOpen()"
                (click)="toggleSideMenu()"
            >
                <i class="mst-icon-menu" aria-hidden="true"></i>
            </button>
        }

        @if (headerConfig().mode === 'back-fixed') {
            <button
                class="mst-header__mobileMenu -back stack row xCenter yCenter hide-l w20 h20 mrAuto fit"
                type="button"
                aria-label="Indietro"
                (click)="navigateTo(headerConfig().backPath!)"
            >
                <i class="mst-icon-chevron-left" aria-hidden="true"></i>
            </button>
        }

        @if (headerConfig().mode === 'back-history') {
            <button
                class="mst-header__mobileMenu -back stack row xCenter yCenter hide-l w20 h20 mrAuto fit"
                type="button"
                aria-label="Indietro"
                (click)="goBack()"
            >
                <i class="mst-icon-chevron-left" aria-hidden="true"></i>
            </button>
        }

        <!-- Logo -->
        <a class="mst-header__logo" routerLink="/home" aria-label="Maria Sole Barbieri — torna alla home">
            <img class="mst-header__logoImg" src="/images/logos/logo-msb-brand-02.svg" alt="Maria Sole Barbieri" width="127" height="52" />
        </a>

        <!-- Desktop navigation -->
        <ul class="mst-header__nav stack-l row-l hide yStart xStart fit mxAuto" role="list" aria-label="Navigazione principale">
            <li class="mst-header__navItem" [class.-active]="isActive('programs')">
                <a class="mst-header__navItemLink" [href]="wpUrl + 'programs-woman/'" (click)="navigateWpOrInternal('/programs', $event)"
                    >Programmi</a
                >
            </li>
            <li class="mst-header__navItem" [class.-active]="isActive('msb4you', true)">
                <a class="mst-header__navItemLink" routerLink="/msb4you">MSB4You</a>
            </li>
            <li class="mst-header__navItem" [class.-active]="isActive('msb4you/2')">
                <a class="mst-header__navItemLink" routerLink="/msb4you/2">Testimonianze</a>
            </li>
            <li class="mst-header__navItem" [class.-active]="isActive('shop')">
                <a class="mst-header__navItemLink" [href]="wpUrl + 'shop'" (click)="navigateWpOrInternal('/shop', $event)">Shop</a>
            </li>
            <li class="mst-header__navItem" [class.-active]="isActive(null)">
                <a class="mst-header__navItemLink" routerLink="/training">My Area</a>
            </li>
            <li class="mst-header__navItem" [class.-active]="isActive('faq')">
                <a class="mst-header__navItemLink" routerLink="/faq">FAQ</a>
            </li>
            <li class="mst-header__navItem" [class.-active]="isActive('contacts')">
                <a class="mst-header__navItemLink" [href]="wpUrl + 'contatti'">Contatti</a>
            </li>
        </ul>

        <!-- Desktop icon links -->
        <ul class="mst-header__icons stack row xStart yStart fit mlAuto" role="list" aria-label="Link rapidi">
            <li class="mst-header__iconsItem -account">
                <a [href]="wpUrl + 'my-account'" class="mst-header__iconsItemLink" aria-label="Il mio account">
                    <i class="mst-icon-user" aria-hidden="true"></i>
                </a>
            </li>
            <!-- <li class="mst-header__iconsItem -favorites">
                <a [href]="wpUrl + 'wishlist-2'" class="mst-header__iconsItemLink" aria-label="Preferiti">
                    <i class="mst-icon-heart" aria-hidden="true"></i>
                </a>
            </li> -->
            <li class="mst-header__iconsItem -cart">
                <a [href]="wpUrl + 'carrello'" class="mst-header__iconsItemLink" aria-label="Carrello">
                    <i class="mst-icon-cart" aria-hidden="true"></i>
                </a>
            </li>
        </ul>

        <!-- Mobile side-drawer -->
        <!-- Backdrop: click area outside drawer closes the menu -->
        <div class="mst-header__mobileNav" [class.-opened]="sideMenuIsOpen()" role="presentation">
            <button
                class="mst-header__mobileNavBackdrop"
                type="button"
                aria-label="Chiudi menu"
                tabindex="-1"
                (click)="closeSideMenu()"
            ></button>
            <nav class="mst-header__mobileNavContainer" aria-label="Navigazione mobile">
                <ul class="mst-header__mobileNavList" role="list">
                    <li class="mst-header__mobileNavListItem" [class.-active]="isActive('programs')">
                        <a
                            class="mst-header__mobileNavListItemLink"
                            [href]="wpUrl + 'programs-woman/'"
                            (click)="navigateWpOrInternal('/programs', $event)"
                            >Programmi</a
                        >
                    </li>
                    <li class="mst-header__mobileNavListItem" [class.-active]="isActive('msb4you')">
                        <a class="mst-header__mobileNavListItemLink" routerLink="/msb4you" (click)="closeSideMenu()">MSB4You</a>
                    </li>
                    <li class="mst-header__mobileNavListItem" [class.-active]="isActive('msb4you/2')">
                        <a class="mst-header__mobileNavListItemLink" routerLink="/msb4you/2" (click)="closeSideMenu()">Testimonianze</a>
                    </li>
                    <li class="mst-header__mobileNavListItem" [class.-active]="isActive('shop')">
                        <a class="mst-header__mobileNavListItemLink" [href]="wpUrl + 'shop'" (click)="navigateWpOrInternal('/shop', $event)"
                            >Shop</a
                        >
                    </li>
                    <li class="mst-header__mobileNavListItem" [class.-active]="isActive(null)">
                        <a class="mst-header__mobileNavListItemLink" routerLink="/training" (click)="closeSideMenu()">My Area</a>
                    </li>
                    <li class="mst-header__mobileNavListItem" [class.-active]="isActive('faq')">
                        <a class="mst-header__mobileNavListItemLink" routerLink="/faq" (click)="closeSideMenu()">FAQ</a>
                    </li>
                    <li class="mst-header__mobileNavListItem" [class.-active]="isActive('contacts')">
                        <a class="mst-header__mobileNavListItemLink" [href]="wpUrl + 'contatti'">Contatti</a>
                    </li>
                    @if (isLoggedIn()) {
                        <li class="mst-header__mobileNavListItem">
                            <button class="mst-header__mobileNavListItemLink" type="button" (click)="logout()">Logout</button>
                        </li>
                    }
                </ul>

                <ul class="mst-header__mobileNavIcons" role="list">
                    <li class="mst-header__mobileNavIconsItem -cart">
                        <a class="mst-header__mobileNavIconsItemLink" [href]="wpUrl + 'carrello'">
                            <span class="mst-header__mobileNavIconsItemIconWrap">
                                <i class="mst-icon-cart" aria-hidden="true"></i>
                            </span>
                            <p class="mst-header__mobileNavIconsItemText">Il tuo carrello</p>
                        </a>
                    </li>
                    <li class="mst-header__mobileNavIconsItem -account">
                        <a class="mst-header__mobileNavIconsItemLink" routerLink="/my-account/purchase-history" (click)="closeSideMenu()">
                            <span class="mst-header__mobileNavIconsItemIconWrap">
                                <i class="mst-icon-user" aria-hidden="true"></i>
                            </span>
                            <p class="mst-header__mobileNavIconsItemText">Account</p>
                        </a>
                    </li>
                </ul>
                @if (isStandaloneMode) {
                    <span class="mst-header__mobileNavVersion">v. {{ version }}</span>
                }
            </nav>
        </div>
    </div>
</header>
